export default () => {
  return {
    namespaced: true,
    state: {
      current: { id: null, name: null },
      list: [],
    },
    getters: {
      current: (state) => state.current.id,
      all: (state) => state.list,
    },
    mutations: {
      SET_CURRENT: (state, { id, name }) => {
        state.current = { id, name };
      },
      ADD_EL: (state, { id, name }) => {
        if (!state.list.some((el) => el.id === id)) {
          state.list = [...state.list, { id, name }];
        }
      },
      REMOVE_EL: (state, id) => {
        state.list = state.list.filter((el) => el.id !== id);
      },
    },
    actions: {
      addCurrent({ commit }, payload) {
        commit('ADD_EL', payload);
        commit('SET_CURRENT', payload);
      },
      remove({ commit }, id) {
        commit('REMOVE_EL', id);
      },
      setModalOpened({ dispatch }, item) {
        dispatch('addCurrent', {
          id: item.property_id,
          name: item.property_shortname,
        });
        dispatch('alerts/setCurrent', item, { root: true });
        dispatch(
          'boilerplate/setModalOpened',
          { component: 'PropertyDialog' },
          { root: true }
        );
      },
      setSensorsOpened({ dispatch }, item) {
        dispatch('addCurrent', {
          id: item.property_id,
          name: item.property_shortname,
        });
        dispatch('alerts/setCurrent', item, { root: true });
        dispatch(
          'boilerplate/setModalOpened',
          { component: 'PropertyDialog', tab: 'sensors' },
          { root: true }
        );
      },
    },
  };
};
